import { Collapse, CollapsePanelProps } from 'antd';
import { CaretRightOutlined } from '@ant-design/icons';
import { COLORS } from 'helpers/constants';

const { Panel } = Collapse;

interface Props {
  panels: Array<PropsPanel>;
  height?: string;
  defaultActiveKey?: string | string[];
}

interface PropsPanel extends CollapsePanelProps {
  children: React.ReactNode;
}

export const SiderCollapse = ({ panels, defaultActiveKey, height }: Props) => {
  return (
    <Collapse
      style={{ backgroundColor: 'transparent', height: '100%' }}
      expandIcon={({ isActive }) => (
        <CaretRightOutlined rotate={isActive ? 90 : 0} style={{ color: COLORS.PRIMARY.GRAY }} />
      )}
      bordered={false}
      defaultActiveKey={defaultActiveKey}
    >
      {panels.map((panelProps) => (
        // eslint-disable-next-line react/jsx-key
        <Panel {...panelProps} style={{ maxHeight: height ?? '30vh', overflowY: 'auto' }} />
      ))}
    </Collapse>
  );
};
